// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__28-sA","empty":"ModalGraph_empty__3ZUlx"};